import * as React from 'react';
import { createFileRoute} from '@tanstack/react-router';
import { BackButton } from '@/components/atoms/BackButton';

export const Route = createFileRoute('/about')({
  component: About,
});

function About() {
  return (
  <div>
    <img src="/public/about_us_hero_image.webp" alt="About us hero" className="w-full object-cover" />
    <div className="mt-4">
      <div className="p-4">
        <BackButton />
      </div>
      <div className="p-4">
        <h1 className="text-3xl font-bold mb-4">Bikes built exactly how you want them.</h1>
        <p className="mt-4">
        Lets face it, your bike is a reflection of you. We love to tinker and upgrade it to suit unique riding styles and aesthetics.
        </p>
        <p className="mt-4">
          But buying a bike is not like that, bikes are mass produced to meet a price point usually with compromises you can't see. These bikes are designed to fit a target rider size, but if you don't fit that target rider dimensions then the bar could be too short, the saddle painful, the cranks the wrong length etc
        </p>
        <p className="mt-4">
          If you're like us and you're constantly compare models and thinking in your head what you would change and how much that is going to cost you and how you're going to sell those parts you're going to swap out whenever you buy a bike.
        </p>
        <p className="mt-4">
          If you're like us and you're constantly compare models and thinking in your head what you would change and how much that is going to cost you and how you're going to sell those parts you're going to swap out whenever you buy a bike.
        </p>
        <h3 className="text-2xl font-bold mt-4">Because you know exactly what works for you</h3>
        <p className="mt-4">
        What if buying your next bike is not like that at all. What if buying your next bike, you get to choose everything exactly how you want it on your bike, from the frame colour, to the exact components you want down to the jockey wheels on the rear deraileur?
        </p>
        <p className="mt-4">
        OMEO was born with a vision for the uncompromising rider to help them get the perfect bike.
        </p>
        <p className="mt-4">
        If you care about the bearings in your jockey wheel, or the size of the jockey wheel, if you obsess about the weight of the chain and you size your chain exactly then OMEO is for you.
        </p>
        <p className="mt-4">
        Here are OMEO we obsess over the details, we take our our when building your bike, we carefully check, double check and triple check everything is exactly how it should be.
        </p>
        <p className="mt-4">
          Here are OMEO we obsess over the details, we take our our when building your bike, we carefully check, double check and triple check everything is exactly how it should be.
        </p>
      </div>
    </div>
  </div>);
}
